import * as React from 'react'
import {createElement, Fragment} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {TestModeBar} from '../../ui/TestModeBar'
import {RecaptchaBlock} from './elements/RecaptchaBlock'
import {PaymentSubmitBlock} from './elements/PaymentSubmitBlock'
import {DynamicSlot} from '../../dynamic/DynamicSlot'
import {DynamicSlotName} from '../../../lib/DynamicSlotName'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import {Block, getBlock} from '../../../lib/Block'
import {FooterInfo} from '../common/elements/FooterInfo'

///////////////////////////////////////////////////////////////////////////////

export const PaymentFormWidget = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const blocks = api.resolveConfig<Block>('paymentWidgetBlocks')

  if (blocks.length === 0) {
    return null
  }

  return (
    <div className="payment-widget">
      <TestModeBar />

      <DynamicSlot name={DynamicSlotName.BLOCKS_START} />

      <TransitionGroup component={null}>
        {blocks.map((block, position) => (
          <CSSTransition
            key={block}
            {...api.ui.getBlockCSSTransitionProps(block)}
          >
            {createElement(getBlock(block), {
              key: block,
              position: position + 1,
            } as any)}
          </CSSTransition>
        ))}
      </TransitionGroup>

      <DynamicSlot name={DynamicSlotName.BLOCKS_END} />

      <TestModeBar />

      {!process.env.IS_CREDIT_CARD_IFRAME && (
        <Fragment>
          <PaymentSubmitBlock />
          <FooterInfo />
        </Fragment>
      )}

      <RecaptchaBlock />
    </div>
  )
})
